<page-toolbar title="Application Variants"></page-toolbar>

<data-table
  (detail)="onDetail($event)"
  [columns]="columns"
  [plainData]="params"
  title="Application Variants"
>
</data-table>
